// extracted by mini-css-extract-plugin
export default {"brand":"brandLogo_brand__M6-lm","mark":"brandLogo_mark__zVYkE"};